module.exports = __webpack_public_path__ + "img/6_108.bd7e5aa0.png";